var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransparentscalablecommunication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Transparent_scalable_communication_",
    "data-name": "Transparent, scalable communication ",
    transform: "translate(-17579 -8465)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_588",
    "data-name": "Ellipse 588",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(17579 8465)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "internal",
    transform: "translate(17596.535 8505)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19717",
    "data-name": "Path 19717",
    d: "M31,404.393v20.655H88.835V404.393A12.407,12.407,0,0,0,76.442,392H43.393A12.407,12.407,0,0,0,31,404.393Z",
    transform: "translate(0 -284.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_629",
    "data-name": "Ellipse 629",
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    transform: "translate(43 75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19718",
    "data-name": "Path 19718",
    d: "M271,404.393v20.655h57.835V404.393A12.407,12.407,0,0,0,316.442,392H283.393A12.407,12.407,0,0,0,271,404.393Z",
    transform: "translate(-173.903 -284.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_630",
    "data-name": "Ellipse 630",
    cx: 17,
    cy: 16.5,
    rx: 17,
    ry: 16.5,
    transform: "translate(109 75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19719",
    "data-name": "Path 19719",
    d: "M61,24.786A24.813,24.813,0,0,0,85.786,49.573v18.57l22.156-18.57h13.523l22.156,18.57V49.573a24.786,24.786,0,1,0,0-49.573H85.786A24.813,24.813,0,0,0,61,24.786Zm66.1-4.131h8.262v8.262H127.1Zm-16.524,0h8.262v8.262h-8.262Zm-16.524,0h8.262v8.262H94.048Z",
    transform: "translate(-21.738)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparentscalablecommunication);
export default __webpack_public_path__ + "static/media/Transparent, scalable communication.7f40863f3c4c482860ea015b0d3805b1.svg";
export { ForwardRef as ReactComponent };